import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import { useTranslation } from "react-i18next";

export const NotificationLMSExamScheduled: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;
    const { t, i18n } = useTranslation()

    const scheduledInfo = actions[0]?.fieldValues;
    const examLink = scheduledInfo["examLink"] || scheduledInfo["ExamLink"];
    const examName_ru = scheduledInfo["examName_ru"] || scheduledInfo["ExamName_ru"];
    const examName_en = scheduledInfo["examName_en"] || scheduledInfo["ExamName_en"];
    const ThemeLink = scheduledInfo["themeLink"] || scheduledInfo["ThemeLink"];
    const themeName_ru = scheduledInfo["themeName_ru"] || scheduledInfo["ThemeName_ru"];
    const themeName_en = scheduledInfo["themeName_en"] || scheduledInfo["ThemeName_en"];
    const startDate = scheduledInfo["startDate"] || scheduledInfo["StartDate"];
    const endTime = scheduledInfo["endTime"] || scheduledInfo["EndTime"];

    if (!scheduledInfo) return null;

    // "lms_date_scheduled": "{{startDate}} - {{startTime}}-{{endTime}}"
    // Название занятия - Название курса - 23.06.2024 - 16:40-18:40

    return <SimpleTitle>
        <a href={examLink}>{i18n.language === 'ru' ? examName_ru : examName_en}{' - '}</a>            
        <a href={ThemeLink}>{i18n.language === 'ru' ? themeName_ru : themeName_en}{' - '}</a>
        {t('notifications.lms_date_scheduled_end', { startDate, endTime })}
    </SimpleTitle>
}import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import { useTranslation } from "react-i18next";

export const NotificationLMSExamScheduled: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;
    const { t, i18n } = useTranslation()

    const scheduledInfo = actions[0]?.fieldValues;
    const examLink = scheduledInfo["examLink"] || scheduledInfo["ExamLink"];
    const examName_ru = scheduledInfo["examName_ru"] || scheduledInfo["ExamName_ru"];
    const examName_en = scheduledInfo["examName_en"] || scheduledInfo["ExamName_en"];
    const ThemeLink = scheduledInfo["themeLink"] || scheduledInfo["ThemeLink"];
    const themeName_ru = scheduledInfo["themeName_ru"] || scheduledInfo["ThemeName_ru"];
    const themeName_en = scheduledInfo["themeName_en"] || scheduledInfo["ThemeName_en"];
    const startDate = scheduledInfo["startDate"] || scheduledInfo["StartDate"];
    const endTime = scheduledInfo["endTime"] || scheduledInfo["EndTime"];

    if (!scheduledInfo) return null;

    // "lms_date_scheduled": "{{startDate}} - {{startTime}}-{{endTime}}"
    // Название занятия - Название курса - 23.06.2024 - 16:40-18:40

    return <SimpleTitle>
        <a href={examLink}>{i18n.language === 'ru' ? examName_ru : examName_en}{' - '}</a>            
        <a href={ThemeLink}>{i18n.language === 'ru' ? themeName_ru : themeName_en}{' - '}</a>
        {t('notifications.lms_date_scheduled_end', { startDate, endTime })}
    </SimpleTitle>
}